/* ═══════════════════════════════════
   Ochsenleder — Produkt Template JS
   ═══════════════════════════════════ */
(function(){
  /* ── Gallery ── */
  var VISIBLE = 5;
  var thumbOffset = 0;
  var activeIndex = 0;
  var allImages = [];      // [{src, alt}, ...] — alle Produktbilder
  var displayImages = [];  // aktuell angezeigte (evtl. nach Farbe gefiltert)

  if (window.oxAllImages && window.oxAllImages.length) {
    allImages = window.oxAllImages;
  }
  displayImages = allImages.slice();

  function renderThumbs() {
    var grid = document.getElementById('oxThumbsGrid');
    if (!grid || displayImages.length === 0) return;
    var slice = displayImages.slice(thumbOffset, thumbOffset + VISIBLE);
    grid.innerHTML = slice.map(function(img, i) {
      var gi = thumbOffset + i;
      return '<div class="ox-thumb' + (gi === activeIndex ? ' active' : '') + '" onclick="window._oxSelectThumb(' + gi + ')">' +
        '<img src="' + img.src + '" alt="">' +
        '</div>';
    }).join('');
    var prev = document.getElementById('oxThumbPrev');
    var next = document.getElementById('oxThumbNext');
    if (prev) prev.style.display = thumbOffset > 0 ? 'flex' : 'none';
    if (next) next.style.display = thumbOffset + VISIBLE < displayImages.length ? 'flex' : 'none';
  }

  window._oxSelectThumb = function(index) {
    activeIndex = index;
    var mainImg = document.getElementById('oxMainImg');
    if (mainImg && displayImages[index]) mainImg.src = displayImages[index].src;
    var lb = document.getElementById('oxLightbox');
    var lbImg = document.getElementById('oxLbImg');
    if (lbImg && lb && lb.classList.contains('open')) lbImg.src = displayImages[index].src;
    renderThumbs();
    updateGalleryArrows();
  };

  function updateGalleryArrows() {
    var prev = document.querySelector('.ox-gallery-arrow--prev');
    var next = document.querySelector('.ox-gallery-arrow--next');
    if (prev) prev.style.display = activeIndex > 0 ? 'flex' : 'none';
    if (next) next.style.display = activeIndex < displayImages.length - 1 ? 'flex' : 'none';
  }

  window._oxGalleryNav = function(dir) {
    var newIndex = activeIndex + dir;
    if (newIndex < 0 || newIndex >= displayImages.length) return;
    if (thumbOffset > newIndex) thumbOffset = newIndex;
    if (newIndex >= thumbOffset + VISIBLE) thumbOffset = newIndex - VISIBLE + 1;
    window._oxSelectThumb(newIndex);
  };

  window._oxShiftThumbs = function(dir) {
    thumbOffset = Math.max(0, Math.min(displayImages.length - VISIBLE, thumbOffset + dir));
    renderThumbs();
  };

  /* ── Gallery Farb-Filter ── */
  function imgMatchesColor(img, colorHandle) {
    if (img.alt && img.alt.indexOf(colorHandle) !== -1) return true;
    var filename = img.src.split('?')[0].split('/').pop().toLowerCase();
    return filename.indexOf(colorHandle) !== -1;
  }

  function filterGallery(colorHandle) {
    if (colorHandle) {
      var filtered = allImages.filter(function(img) { return imgMatchesColor(img, colorHandle); });
      displayImages = filtered.length > 0 ? filtered : allImages.slice();
    } else {
      displayImages = allImages.slice();
    }
    activeIndex = 0;
    thumbOffset = 0;
    renderThumbs();
    var mainImg = document.getElementById('oxMainImg');
    if (mainImg && displayImages[0]) mainImg.src = displayImages[0].src;
    updateGalleryArrows();
  }

  // Beim Laden: aktive Swatch-Farbe auto-filtern
  var activeSwatch = document.querySelector('.ox-swatch.active');
  if (activeSwatch) filterGallery(activeSwatch.dataset.color);

  renderThumbs();
  updateGalleryArrows();

  /* ── Varianten-Wechsel ── */
  window._oxVariantOption = function(optionIndex, value, colorHandle, swatchEl) {
    var opts = window.oxSelectedOptions || [];
    opts[optionIndex] = value;
    window.oxSelectedOptions = opts;

    // Swatch: active-State + Name-Label
    if (swatchEl && swatchEl.classList.contains('ox-swatch')) {
      document.querySelectorAll('.ox-swatch').forEach(function(s) { s.classList.remove('active'); });
      swatchEl.classList.add('active');
      var nameEl = document.getElementById('oxSwatchName');
      if (nameEl) nameEl.textContent = value;
    }

    // Passende Variante suchen
    var variants = window.oxVariantData || [];
    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) { match = v; break; }
    }

    if (match) {
      // Formular-ID aktualisieren
      var idInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
      if (idInput) idInput.value = match.id;

      // Preis aktualisieren
      var priceEl = document.getElementById('oxPrice');
      if (priceEl) {
        priceEl.textContent = (match.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      }

      // Hauptbild zur Variante wechseln
      if (match.featured_image && match.featured_image.src) {
        var src = match.featured_image.src.replace(/\?.*$/, '') + '?width=1200';
        var mainImg = document.getElementById('oxMainImg');
        if (mainImg) mainImg.src = src;
      }
    }

    // Galerie nach Farbe filtern
    if (colorHandle) filterGallery(colorHandle);
  };

  /* ── Accordions ── */
  window._oxToggleAcc = function(id) {
    var item = document.getElementById(id);
    if (!item) return;
    var isOpen = item.classList.contains('open');
    item.classList.toggle('open');
    var icon = item.querySelector('.ox-accordion-icon');
    if (icon) icon.textContent = isOpen ? '+' : '−';
  };

  /* ── Lightbox ── */
  window._oxOpenLightbox = function() {
    var lb = document.getElementById('oxLightbox');
    var img = document.getElementById('oxLbImg');
    if (lb && img && displayImages[activeIndex]) {
      img.src = displayImages[activeIndex].src;
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      updateLightboxArrows();
    }
  };
  window._oxCloseLightbox = function() {
    var lb = document.getElementById('oxLightbox');
    if (lb) { lb.classList.remove('open'); document.body.style.overflow = ''; }
  };
  window._oxLightboxNav = function(dir) {
    var newIndex = activeIndex + dir;
    if (newIndex < 0 || newIndex >= displayImages.length) return;
    window._oxSelectThumb(newIndex);
    updateLightboxArrows();
  };
  function updateLightboxArrows() {
    var prev = document.querySelector('.ox-lightbox-nav--prev');
    var next = document.querySelector('.ox-lightbox-nav--next');
    if (prev) prev.style.display = activeIndex > 0 ? 'flex' : 'none';
    if (next) next.style.display = activeIndex < displayImages.length - 1 ? 'flex' : 'none';
  }

  /* ── Messen Popup ── */
  window._oxOpenMessenPopup = function() {
    var el = document.getElementById('oxMessenPopup');
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window._oxCloseMessenPopup = function() {
    var el = document.getElementById('oxMessenPopup');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ── Initialen Popup ── */
  window._oxOpenInitialsPopup = function() {
    var el = document.getElementById('oxInitialsPopup');
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window._oxCloseInitialsPopup = function() {
    var el = document.getElementById('oxInitialsPopup');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ── Schriftzug Popup ── */
  window._oxOpenSchriftzugPopup = function() {
    var el = document.getElementById('oxSchriftzugPopup');
    if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
  };
  window._oxCloseSchriftzugPopup = function() {
    var el = document.getElementById('oxSchriftzugPopup');
    if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
  };

  /* ── Pflichtfeld Validierung ── */
  var cartForm = document.querySelector('form[action="/cart/add"]');
  if (cartForm) {
    cartForm.addEventListener('submit', function() {
      var laenge = document.getElementById('oxLaenge');
      var confirm = document.getElementById('oxMessenConfirm');
      if (laenge) laenge.classList.add('ox-touched');
      if (confirm) confirm.classList.add('ox-touched');
    });
  }

  /* ── Keyboard Navigation ── */
  document.addEventListener('keydown', function(e) {
    var lbOpen = document.getElementById('oxLightbox').classList.contains('open');
    if (e.key === 'Escape') {
      _oxCloseLightbox(); _oxCloseMessenPopup(); _oxCloseInitialsPopup(); _oxCloseSchriftzugPopup();
    } else if (e.key === 'ArrowLeft') {
      if (lbOpen) _oxLightboxNav(-1); else _oxGalleryNav(-1);
    } else if (e.key === 'ArrowRight') {
      if (lbOpen) _oxLightboxNav(1); else _oxGalleryNav(1);
    }
  });

})();
